import {Injectable} from '@angular/core';
import {catchError, map} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

export interface TimeSeriesDashboard {
  countTimeSeries: number;
  parameters: TimeSeriesDashboardData[];
  countries: TimeSeriesDashboardData[];
  years: TimeSeriesDashboardData[];
  monitoringStations: TimeSeriesDashboardData[];
}

export interface TimeSeriesDashboardData {
  label: string;
  key: string;
  value: number;
}


@Injectable({
  providedIn: 'root'
})
export class TimeSeriesDashboardService {

  constructor(private http: HttpClient) {
  }

  fetchDashboardData(): Observable<TimeSeriesDashboard> {
    return this.http.get<TimeSeriesDashboard>(`${environment.tsBase}ts/dashboard/inventory`)
      .pipe(
        map((res: any) => {
            // console.log(res);
            return res;
          }
        ),
        catchError(err => throwError('Cannot get time-series JSON'))
      );
  }
}
